// @flow
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import type { StateType, DispatchType } from "../../../global/types/redux";
import type { ErrorsType } from "../../types/UserFormType";
import { ErrosDisplay, WarningDisplay } from "../ErrosDisplay";
import {
  CancelButton,
  SubmitButton,
  LoadingProgress,
  MultiLineStrings,
  SingleCheckBox,
  NoItem
} from "imagus-components";
import {
  fetchCompanies,
  broadcastSoftware,
  fetctAllUsers
} from "../../actions/softwareActions";
import { PrimaryGreen } from "../../../global/uis/scss";

import Grid from "@material-ui/core/Grid";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Checkbox from "@material-ui/core/Checkbox";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import ChipInput from "../../../global/components/ChipInput";
import { propComparator } from "../../../global/functions/StringOperations";

type BroadcastFormStatesType = {
  errors: ErrorsType,
  loading: boolean,
  users: Array<*>
};

type BroadcastFormPropsType = {
  softwareId: string,
  onClose: Function,
  currentVersion: { [key: string]: * }
};

class BroadcastForm extends Component<
  BroadcastFormStatesType,
  BroadcastFormPropsType
> {
  constructor(props: BroadcastFormStatesType) {
    super(props);
    this.submit = this.submit.bind(this);
    this.state = {
      errors: {},
      loading: false,
      users: [],
      filters: [],
      searches: [],
      selectAll: false
    };
  }

  setUsers = (companies: *): * => {
    let users = [];
    console.log("filter list before: ", this.state.filters);
    console.log("companies: ", companies);
    let filterList = [...this.state.filters];
    companies.forEach((company: *, i: number): * => {
      if (company.users.edges && company.users.edges.length > 0) {
        console.log("doing comp: ", company.name);
        company.users.edges.forEach((user: *, j: number): * => {
          users.push({
            id: user.node.id,
            uuid: user.node.cognitoUuid,
            name: user.node.fullName,
            company: company.name,
            companyId: company.id,
            type: company.companyType
          });
          //append to companyType list

          let isInFilterList =
            filterList.findIndex((f) => f.name === company.companyType) > -1;
          console.log(
            "is " + company.companyType + " in filter: ",
            isInFilterList
          );
          if (!isInFilterList) {
            filterList.push({ name: company.companyType, checked: true });
          }
        });
      }
    });

    this.setState({ users: users, filters: filterList }, (): * => {
      if (this.props.users === null) {
        this.props.actions.fetctAllUsers(this.setEmails);
      } else {
        this.setEmails(this.props.users);
      }
    });
  };

  setEmails = (emails: *): * => {
    let users = [...this.state.users];
    users.forEach((user: *, i: number): * => {
      let email = emails[user.uuid].email;
      user.email = email;
      user.checked = false;
      user.displayed = true;
      users[i] = user;
    });

    this.setState({ users: users });
  };

  componentDidMount() {
    if (this.props.companies === null) {
      this.props.actions.fetchCompanies(this.setUsers);
    } else {
      this.setUsers(this.props.companies);
    }
  }

  handleChange =
    (userId: string): * =>
    (e: Event): * => {
      let users = [...this.state.users];
      let index = users.findIndex((x) => x.id === userId);
      let user = { ...users[index] };
      user.checked = e.target.checked;

      //update select all status
      let selectAll = this.state.selectAll;
      if (user.displayed && !user.checked) selectAll = false;

      users[index] = user;
      this.setState({ users: users, selectAll: selectAll });
    };

  handleFilterChange = (name: string) => (e: Event) => {
    let filters = [...this.state.filters];
    let index = filters.findIndex((f) => f.name === name);
    let filter = { ...filters[index] };

    filter.checked = e.target.checked;

    let users = [...this.state.users];
    users.map((user) => {
      if (user.type === name) {
        user.displayed = e.target.checked;
        //user checked and select all will default to false on filter selected
        user.checked = false;
      }
    });

    filters[index] = filter;
    this.setState({ filters: filters, selectAll: false, users: users });
  };

  handleCompanySelect = (name: string, value: string[]) => {
    this.setState({ [name]: value });

    //update user list
    let users = [...this.state.users];

    let selectAll = this.state.selectAll;
    users.forEach((u) => {
      let matchedTypeFilter =
        this.state.filters.findIndex((f) => f.checked && f.name === u.type) >
        -1;

      if (
        value.includes(u.companyId) ||
        (value.length === 0 && matchedTypeFilter)
      ) {
        u.displayed = true;
      } else {
        u.checked = false;
        u.displayed = false;
      }

      //update selectAll status
      if (u.displayed && !u.checked) selectAll = false;

      this.setState({ users: users, selectAll: selectAll });
    });
  };

  submit = (e: Event): * => {
    e.preventDefault();
    e.stopPropagation();
    if (Object.keys(this.state.errors).length === 0) {
      this.setState((): * => ({ loading: true }));

      let emails = [];
      this.state.users.forEach((user: *): * => {
        if (user.email && user.checked) {
          emails.push(user.email);
        }
      });

      this.props.actions.broadcastSoftware(
        this.props.softwareId,
        emails,
        this.submitDone,
        this.submitFail
      );
    }
  };

  submitDone = () => {
    this.props.onClose();
  };

  submitFail = (errors: ErrorsType): * => {
    this.setState({
      errors: errors,
      loading: false
    });
  };

  render(): React$Element<*> {
    const errors = this.state.errors;
    const loading = this.state.loading;
    const currentVersion = this.props.currentVersion;

    let users = [];
    this.state.users.forEach((user: *, i: number): * => {
      if (user.displayed) {
        users.push(
          <TableRow key={i}>
            <TableCell padding="dense">
              {user.email ? (
                <Checkbox
                  style={{ color: PrimaryGreen }}
                  onChange={this.handleChange(user.id)}
                  checked={user.checked}
                />
              ) : null}
            </TableCell>
            <TableCell padding="dense">{user.name}</TableCell>
            <TableCell padding="dense">{user.email}</TableCell>
            <TableCell padding="dense">{user.company}</TableCell>
            <TableCell padding="dense">{user.type}</TableCell>
          </TableRow>
        );
      }
    });

    //select companies
    const companies = this.props.companies ? [...this.props.companies] : [];
    let searchList = [];

    //put the company into the search list if the type is selected
    companies.forEach((company) => {
      let index = this.state.filters.findIndex(
        (f) => f.checked && f.name === company.companyType
      );

      if (index > -1) {
        searchList.push({ value: company.id, label: company.name });
      }
    });

    searchList.sort(propComparator("label", true));

    /** To check whether any filter is selected */
    let filterStatus = [];
    /** To display filter selection */
    let filterList = [];
    this.state.filters.forEach((type, i: number) => {
      filterList.push(
        <SingleCheckBox
          key={`filter-${i}`}
          name={type.name}
          label={type.name}
          onChange={this.handleFilterChange(type.name)}
          value={type.checked}
        />
      );
      filterStatus.push(type.checked);
    });

    return (
      <form
        onSubmit={(!loading && this.submit) || undefined}
        className="app-wrapper"
      >
        <div className="app-panel">
          <div className="app-panel-content">
            <Grid container spacing={8}>
              <Grid item xs={12}>
                {currentVersion.isCurrent ? (
                  <Paper>
                    <Typography variant="h5" className="form-text">
                      Current Version
                    </Typography>
                    <Table
                      className="app-table no-border"
                      style={this.props.tableStyle}
                    >
                      <TableBody>
                        <TableRow>
                          <TableCell padding="dense" className="border">
                            Version
                          </TableCell>
                          <TableCell padding="dense">
                            {currentVersion.versionId}
                          </TableCell>
                          <TableCell padding="dense" className="border">
                            Released On
                          </TableCell>
                          <TableCell padding="dense">
                            {currentVersion.releaseDate}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell padding="dense" className="border">
                            Link
                          </TableCell>
                          <TableCell padding="dense" colSpan={3}>
                            {currentVersion.link}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell padding="dense" className="border">
                            Release Notes
                          </TableCell>
                          <TableCell padding="dense" colSpan={3}>
                            <MultiLineStrings
                              val={currentVersion.releaseNotes}
                            />
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </Paper>
                ) : (
                  <WarningDisplay
                    warning="Can NOT found the current version."
                    display
                  />
                )}
              </Grid>
              <Grid item xs={12} container>
                <Grid item xs={12} md={6}>
                  <Typography>
                    Filter by:{" "}
                    <span style={{ marginLeft: "10px" }}>{filterList}</span>
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <ChipInput
                    name="searches"
                    isMultiple
                    placeholder="All Companies"
                    value={this.state.searches}
                    syncChange={this.handleCompanySelect}
                    tags={searchList}
                  />
                </Grid>
              </Grid>
              <Grid item xs={12}>
                {this.state.users && this.state.users.length > 0 ? (
                  users.length > 0 ? (
                    <Table className="app-table">
                      <TableHead>
                        <TableRow>
                          <TableCell className="blue-shine">
                            Selected{" "}
                            <SingleCheckBox
                              key={`select-all`}
                              name={"allUsers"}
                              value={this.state.selectAll}
                              // label={"Selected"}
                              onChange={(e: Event) => {
                                console.log("got to here");
                                let users = [...this.state.users];
                                users.map((user) => {
                                  if (user.displayed) {
                                    user.checked = e.target.checked;
                                  }
                                });
                                this.setState({
                                  selectAll: e.target.checked,
                                  users: users
                                });
                              }}
                            />
                          </TableCell>
                          <TableCell className="blue-shine">
                            User Name
                          </TableCell>
                          <TableCell className="blue-shine">Email</TableCell>
                          <TableCell className="blue-shine">
                            Company Name
                          </TableCell>
                          <TableCell className="blue-shine">
                            Company Type
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>{users}</TableBody>
                    </Table>
                  ) : (
                    <NoItem content="No company matches selected filters" />
                  )
                ) : (
                  <LoadingProgress />
                )}
              </Grid>
              <Grid item xs={12}>
                <ErrosDisplay errors={errors} form="add version" />
              </Grid>
              <Grid item xs={12}>
                <div className="form-right-btn-block">
                  <CancelButton onClick={this.props.onClose} />
                  {currentVersion.isCurrent && (
                    <SubmitButton
                      loading={loading}
                      disabled={Object.keys(errors).length > 0}
                    />
                  )}
                </div>
              </Grid>
            </Grid>
          </div>
        </div>
      </form>
    );
  }
}

const mapStateToProps = (state: StateType): * => ({
  companies: state.v3account.software.companies,
  users: state.v3account.software.users
});

const mapDispatchToProps = (dispatch: DispatchType): DispatchType => ({
  actions: bindActionCreators(
    { fetchCompanies, broadcastSoftware, fetctAllUsers },
    dispatch
  )
});

export default connect(mapStateToProps, mapDispatchToProps)(BroadcastForm);
